//      
import {
  withScroll,
  offset as offsetBox,
                
                
} from 'css-box-model';
                                                      

              
                                
                   
                                
   

export default ({
  draggable,
  offset,
  initialWindowScroll,
}      )                     => {
  const client           = offsetBox(draggable.client, offset);
  const page           = withScroll(client, initialWindowScroll);

  const moved                     = {
    ...draggable,
    placeholder: {
      ...draggable.placeholder,
      client,
    },
    client,
    page,
  };

  return moved;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/publish-while-dragging-in-virtual/offset-draggable.js